export default __webpack_public_path__ + "static/media/service-3.ec5f8732.png";